import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

import LeetCodeView from "./pages/LeetCodeView";
import OpenKattisView from "./pages/OpenKattisView";

function App() {
  
  return (
    <>
      <Router>
        <Navbar/>
        <Routes>
          <Route path='/' element={<OpenKattisView/>} />
          <Route path='/leet-code' element={<LeetCodeView/>} />
          <Route path='/open-kattis' element={<OpenKattisView/>} />
        </Routes>
        <Footer/>
      </Router>
    </>
  );
}

export default App;
